import { errorLogger } from "../../shared/services/error-logger";
import React from "react";

type ErrorDisplayProps = {
  category: string;
};

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ category }) => {
  const errors = errorLogger.getErrorsByCategory(category);

  if (errors.length === 0) return null;

  return (
    <div className="grid grid-cols-5 gap-2 rounded bg-red-100 p-2">
      <h4 className="col-span-5 mb-1 text-sm font-semibold text-red-700">Errors:</h4>
      {errors.map((err, idx) => (
        <div key={idx} className="col-span-5 text-sm text-red-700">
          <span className="font-semibold">{err.section}:</span>
          <span className="pl-1">{err.message}</span>
        </div>
      ))}
    </div>
  );
};
